export const GET_PERMISSIONS = 'GET_PERMISSIONS'; 
export const GET_PERMISSIONS_SUCCESS = 'GET_PERMISSIONS_SUCCESS'; 
export const SET_PERMISSIONS = 'SET_PERMISSIONS'; 